import { cn } from "lib/utils";

/** Shared selected/hover styles for sidebar contact and condo rows. */
export function contactListItemClasses(
  isSelected: boolean,
  options?: { muted?: boolean; inactive?: boolean; clickable?: boolean }
): string {
  const { muted = false, inactive = false, clickable = true } = options ?? {};
  const dimmed = (muted || inactive) && !isSelected;

  return cn(
    "p-2 rounded-r transition-colors border-l-4",
    clickable ? "cursor-pointer" : "cursor-default",
    isSelected
      ? "border-l-primary bg-primary/5 font-medium"
      : "border-l-transparent hover:bg-stone-50",
    dimmed && "bg-gray-50 opacity-60"
  );
}
